import React from 'react'
import CheckBox from 'shared/ui/CheckBox/CheckBox'
import SelectDropdown from 'shared/ui/SelectDropdown/SelectDropdown'
import { ReactComponent as PersonIcon } from 'assets/icons/person.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg'
import { CONTACT_TYPE_LABELS } from '../../data/parentNotificationData'
import s from './ContactModal.module.scss'

/** Modal overlay is z-index 9999; dropdown portal must render above it. */
const DROPDOWN_MENU_Z_INDEX = 10050

const CONTACT_TYPE_OPTIONS = Object.entries(CONTACT_TYPE_LABELS).map(
	([value, label]) => ({ value, label }),
)

export const ContactFields = ({
	values,
	onFieldChange,
	nameId,
	emailId,
	typeId,
	primaryLabel = 'Is primary contact',
}) => (
	<>
		<div className={s.fieldsRow}>
			<label htmlFor={nameId} className={s.field}>
				<span className={s.field__label}>Contact name</span>
				<div className={s.inputWrap}>
					<span className={s.fieldIcon} aria-hidden="true">
						<PersonIcon />
					</span>
					<input
						id={nameId}
						className={s.inputWrapInput}
						type="text"
						required
						value={values.contact_name || ''}
						onChange={event => onFieldChange('contact_name', event.target.value)}
					/>
				</div>
			</label>
			<label htmlFor={emailId} className={s.field}>
				<span className={s.field__label}>Email</span>
				<div className={s.inputWrap}>
					<span className={s.fieldIcon} aria-hidden="true">
						<MailIcon />
					</span>
					<input
						id={emailId}
						className={s.inputWrapInput}
						type="email"
						required
						value={values.email || ''}
						onChange={event => onFieldChange('email', event.target.value)}
					/>
				</div>
			</label>
		</div>

		<div className={s.field}>
			<span className={s.field__label} id={typeId}>
				Contact type
			</span>
			<SelectDropdown
				value={values.contact_type || 'parent'}
				onChange={next => onFieldChange('contact_type', next)}
				options={CONTACT_TYPE_OPTIONS}
				placeholder="Select contact type"
				minMenuWidth={240}
				menuZIndex={DROPDOWN_MENU_Z_INDEX}
			/>
		</div>

		<div className={s.checkRow}>
			<CheckBox
				isSelected={Boolean(values.is_primary)}
				onToggle={() => onFieldChange('is_primary', !values.is_primary)}
			/>
			<span className={s.checkRow__label}>{primaryLabel}</span>
			<span
				className={s.checkRow__info}
				title="Primary contact is the default recipient for parent updates."
				aria-hidden="true"
			>
				<InfoIcon />
			</span>
		</div>
	</>
)

export default ContactFields
